module.exports = __webpack_public_path__ + "img/27_45.d6ff7fcc.png";